import { JBGApi } from './api'
import { AuthService } from './auth'

export class StripeApi extends JBGApi {
    private authService: AuthService

    constructor(options: StripeApi.Options) {
        super(options.binjpipeUrl, options.authService)
        this.authService = options.authService
    }

    public async createCheckoutSession(productSlug: string): Promise<Response|JBGApi.Error> {
        try {
            const route = 'stripe/checkout/session'
            const options = this.buildOptions('POST', {
                name: productSlug
            })

            return this.callAPI<StripeApi.CreateCheckoutResponse>(route, options)
        } catch (error) {
            return error as JBGApi.Error
        }
    }

    public async createCustomerPortalSession(): Promise<Response|JBGApi.Error> {
        try {
            const route = 'stripe/portal/session'
            const options = this.buildOptions('POST', {})

            return this.callAPI<StripeApi.CreateCustomerPortalSessionResponse>(route, options)
        } catch (error) {
            return error as JBGApi.Error
        }
    }
}

export namespace StripeApi {
    export interface Options {
        authService: AuthService
        binjpipeUrl: string
    }

    export interface CreateCheckoutRequest {
        name: string // Stripe product name
    }

    export interface CreateCheckoutResponse {
        ID: string // Stripe checkout session ID
        URL: string
    }

    export interface CreateCustomerPortalSessionResponse {
        id: string // ID of an existing stripe portal configuration to use for this session
        url: string // stripe portal url
        return_url: string // where users redirect after visiting portal
    }
}
